import React from "react";
import { ButtonBase } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const CloseCameraButton = ({ onClick }) => (
  <ButtonBase
    data-id="close-camera"
    onClick={onClick}
    sx={{ position: "absolute", right: 15, top: 15, zIndex: 99 }}
  >
    <ClearIcon htmlColor="white" fontSize="large" />
  </ButtonBase>
);

export default CloseCameraButton;
